// Shared in-memory cache of the current user's "notify me" subscriptions, so every
// NotifyButton in the roster tables can show the right state without each firing its
// own API request. Refreshed on login/logout and after every subscribe/unsubscribe.
import { fetchSubscriptions, subscribePerformer, unsubscribePerformer } from "../api";
import { getSessionToken } from "./auth";

let cache = new Set();

const cacheKey = (venue, performerName) => `${venue}::${performerName}`.toLowerCase();

export async function loadSubscriptions() {
  if (!getSessionToken()) {
    cache = new Set();
    window.dispatchEvent(new CustomEvent("subscriptions-changed"));
    return;
  }
  try {
    const subs = await fetchSubscriptions();
    cache = new Set(subs.map((s) => cacheKey(s.venue, s.performer_name)));
  } catch {
    cache = new Set();
  }
  window.dispatchEvent(new CustomEvent("subscriptions-changed"));
}

export function isSubscribed(venue, performerName) {
  return cache.has(cacheKey(venue, performerName));
}

export async function toggleSubscription(venue, performerName) {
  const key = cacheKey(venue, performerName);
  if (cache.has(key)) {
    await unsubscribePerformer(venue, performerName);
    cache.delete(key);
  } else {
    await subscribePerformer(venue, performerName);
    cache.add(key);
  }
  window.dispatchEvent(new CustomEvent("subscriptions-changed"));
}

window.addEventListener("auth-changed", () => {
  loadSubscriptions();
});
